import React from 'react';
import { connect } from 'react-redux';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import moment from 'moment';
import _ from 'lodash';
import Translate from 'translate';

import ChannelCaseService from 'services/ChannelCaseService'
import { toggleLoading } from 'stores/actions/';

class StuckDetail extends React.Component {

  render() {
    const { data, onClose, open } = this.props;

    return (
      <Modal closeOnEsc={false}
             little
             modalClassName="col-md-6"
             open={open}
             onClose={onClose}>
        <h5 className="mt-0"><Translate id="detail"/></h5>

        {!!data &&
        <div>
          <div className="row">
            <div className="col-md-6">
              <p><strong><Translate id="queue"/>:</strong> {data.queue || '---'}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="command"/>:</strong> {data.command || '---'}</p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate
                id="createdAt"/>:</strong> {moment( data.createdAt ).format( 'DD/MM/YYYY h:mm A' )}
              </p>
            </div>
            <div className="col-md-6">
              <p><strong><Translate id="state"/>:</strong> {data.state || '---'}</p>
            </div>
          </div>
    
          <div className="row" style={{maxHeight: '200px', overflowY: 'auto', wordBreak: 'break-all'}}>
            <div className="col-md-12">
              <p><strong><Translate id="stuckError"/>:</strong> {data.errorOutput || '---'}</p>
            </div>
          </div>
        </div>
        }
      </Modal>
    )
  }
}

module.exports = StuckDetail;




// WEBPACK FOOTER //
// ./routes/app/components/Management/StuckDetail/index.js